var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invite-button",class:{ 'is-plain': _vm.plain },on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }